/** General JS Utils for V2 **/

import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

const SANITIZE_CONFIG = {
  ALLOWED_TAGS: ['a', 'b', 'i', 'em', 'strong', 'br', 'p', 'ul', 'ol', 'li'],
  ALLOWED_ATTR: ['href', 'target', 'rel']
};

export const renderSafeHtml = (html) => parse(DOMPurify.sanitize(html || '', SANITIZE_CONFIG));

export const contains = (items, comparator) => {
  for (let item of items) {
    if (item === comparator) {
      return true;
    }
  }
  return false;
}

const DEFAULT_LOCALE = "en-US";
const DEFAULT_CURRENCY = "USD";
const DEFAULT_PERCENT_MIN_FRACTION = 0;
const DEFAULT_PERCENT_MAX_FRACTION = 2;
const DEFAULT_CURRENCY_MIN_FRACTION = 2;
const DEFAULT_CURRENCY_MAX_FRACTION = 2;

const setLocaleForNumberFormat = (locale) => {
  if (Intl.NumberFormat.supportedLocalesOf(locale).length >= 1) {
    return locale;
  }
  return DEFAULT_LOCALE;
}

export const formatCurrency = (
  locale,
  value,
  minFraction = DEFAULT_CURRENCY_MIN_FRACTION,
  maxFraction = DEFAULT_CURRENCY_MAX_FRACTION,
  currency = DEFAULT_CURRENCY
) => {
  return new Intl.NumberFormat(
    setLocaleForNumberFormat(locale), {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: minFraction,
      maximumFractionDigits: maxFraction
    }).format(value);
}

export const formatPercentage = (
  locale,
  value,
  minFraction = DEFAULT_PERCENT_MIN_FRACTION,
  maxFraction = DEFAULT_PERCENT_MAX_FRACTION
) => {
  return new Intl.NumberFormat(
    setLocaleForNumberFormat(locale), {
      style: 'percent',
      minimumFractionDigits: minFraction,
      maximumFractionDigits: maxFraction
    }).format(value);
}

export const formatNumber = (locale, value) => {
  return new Intl.NumberFormat(setLocaleForNumberFormat(locale)).format(value);
}
